import { useEffect, useState } from 'react'

export const useOrigin = (initOrigin?: string) => {
	const [origin, setOrigin] = useState(
		initOrigin || 'https://curriculum.nsw.edu.au',
	)
	useEffect(() => {
		const urlObj = new URL(window.location.href)
		setOrigin(urlObj.origin)
	}, [])

	return origin
}

export const useCurrentUrl = (isWithOrigin = true, isEncoded = false) => {
	const [currentUrl, setCurrentUrl] = useState('')
	const origin = useOrigin()
	useEffect(() => {
		const urlObj = new URL(window.location.href)
		let _tempUrl = isWithOrigin
			? urlObj.toString()
			: urlObj.href.replace(origin, '')
		if (isEncoded) {
			_tempUrl = encodeURIComponent(_tempUrl)
		}
		setCurrentUrl(_tempUrl)
	}, [origin])

	return currentUrl
}
